import { AiEngineDataType } from "./enums";

export const AiEnginePaths = {
  [AiEngineDataType.MoreOnThisTopic]: "/recommend/next",
  [AiEngineDataType.MyNewsFresh]: "/recommend/my-news/fresh",
  [AiEngineDataType.OnBoard]: "/recommend/on-board",
  [AiEngineDataType.TopPicks]: "/recommend/top-picks",
  [AiEngineDataType.HomeRecommendedForYou]: "/recommend/home",
  [AiEngineDataType.HomeYouMayHaveMissed]: "/recommend/may-have-missed",
};

export const AiFallbackPaths = {
  [AiEngineDataType.MoreOnThisTopic]: "/rec-backup/next.json",
  [AiEngineDataType.MyNewsFresh]: "/rec-backup/my-news/fresh.json",
  [AiEngineDataType.OnBoard]: "/rec-backup/on-board",
  [AiEngineDataType.TopPicks]: "/rec-backup/top-picks.json",
  [AiEngineDataType.HomeYouMayHaveMissed]: "/rec-backup/may-have-missed.json",
  [AiEngineDataType.HomeRecommendedForYou]: "/rec-backup/home.json",
};
